import React from 'react';

import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';

import { UpdateFullnameService } from 'services/auth';

import TextInput from '@core/components/textinput/TextInput';

import classes from './UserFullName.module.scss';

const UserFullName = ({ title, description, button = 'Submit', callback }) => {
	const { mutate: updateFullName } = useMutation(UpdateFullnameService, {
		onSuccess: () => {
			callback();
		}
	});
	const {
		register,
		handleSubmit,
		formState: { errors, isDirty, isValid }
	} = useForm({ mode: 'onChange' });

	const onSubmitName = (fullnameData) => {
		updateFullName(fullnameData);
	};
	return (
		<div className={`${classes['verify-name-wrapper']} w-100 d-flex flex-column`}>
			{title && <h1>{title}</h1>}
			<p>{description}</p>
			<form onSubmit={handleSubmit(onSubmitName)}>
				<TextInput
					validation={{
						required: true
					}}
					input={{
						type: 'text',
						label: 'First Name',
						name: 'first_name',
						placeholder: 'First Name',
						id: 'first_name'
					}}
					errors={errors}
					register={register}
				/>
				<TextInput
					validation={{
						required: true
					}}
					input={{
						type: 'text',
						label: 'Last Name',
						name: 'last_name',
						placeholder: 'Last Name',
						id: 'last_name'
					}}
					errors={errors}
					register={register}
				/>
				<label className={`${classes['verify-name-checkbox']} `} htmlFor="verify">
					<p>
						I verify that this is my full name for the use in my account and on my certificates.
					</p>
					<input
						type="checkbox"
						name="verify"
						id="verify"
						{...register('verify', {
							required: true
						})}
					/>
					<span></span>
				</label>
				<button type="submit" className="w-100" disabled={!isDirty || !isValid}>
					{button}
				</button>
			</form>
		</div>
	);
};

export default UserFullName;
